<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Manage metadata'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.MetadataManage"
							>
								<div
									class="layout-block vertical"
									style="padding: 2em"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container
										*ngFor="let file of _ForBlock_collectionCode_58({ app, screen, $pathSegments, $disabled }); let fileIndex = index; trackBy: trackByAutomatic"
									>
										<ng-container *lowgileScope="file; as: 'file'; let $scope">
											<ng-container
												*lowgileScope="fileIndex; as: 'fileIndex'; let $scope"
											>
												<mat-card>
													<mat-card-header>
														<mat-card-title
															><span
																[innerHtml]="file.label | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span
														></mat-card-title>
														<mat-card-subtitle
															><span
																[innerHtml]="file.hint | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span
														></mat-card-subtitle>
													</mat-card-header>

													<mat-card-content>
														<div
															class="layout-block"
															style="margin: 0.5em"
															[style.align-items]="'inherit'"
															[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
															[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
															[style.gap]="'1em'"
														>
															<div
																class="layout-block vertical"
																[style.align-items]="'inherit'"
																[style.gap]="'1em'"
															>
																<ng-container
																	*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.timeStamps[file.id])) as $disabled"
																>
																	<button
																		mat-raised-button
																		class="has-click-handler"
																		color="basic"
																		(click)="handler_ButtonBlock_63_click_$adhoc_0($event, { file, fileIndex, $disabled: $disabled })"
																		[disabled]="$disabled"
																	>
																		<mat-icon
																			>{{'file_download'}}</mat-icon
																		><span
																			[innerHtml]="'Download current file' | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</button>
																</ng-container>
																<span
																	[innerHtml]="`Last updated: ${screen.timeStamps[file.id] ? Sys.Date.format(screen.timeStamps[file.id], 'dd.MM.yy, HH:mm') : 'Never'}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</div>
															<app-file-upload
																class="has-filesSelected-handler"
																(filesSelected)="handler_FileUploadBlock_64_filesSelected_$adhoc_0($event, { file, fileIndex, $disabled: $disabled })"
																[multiple]="false"
																[allowedMimeTypes]="file.mimeType"
																[disabled]="$disabled"
																displayStyle="dropZone"
																[uploadToServer]="false"
																color="basic"
															>
																<span
																	[innerHtml]="'Click or drop new file here to upload a new version' | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span>
															</app-file-upload>
														</div>
													</mat-card-content>
												</mat-card>
											</ng-container>
										</ng-container>
									</ng-container>
									<ng-container
										*ngIf="Sys.User.currentUser; else else56"
									></ng-container>
									<ng-template #else56>
										<h2
											[innerHtml]="'Click icon at the top right to log in' | escapeHtml: 'none' | replaceNewlines: 'h2'"
										></h2>
									</ng-template>
								</div>
							</div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.MetadataManage"
							></div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
